import React from 'react'

const PausedJobs = () => {
  return (
    <div>PausedJobs</div>
  )
}

export default PausedJobs